const triggerSelector = '[data-action~="click->dropdown#toggle"]'

export function dropdownTriggerFor(menu) {
  return menu.closest('[data-controller~="dropdown"]')?.querySelector(triggerSelector)
}

export function closeDropdownMenu(menu, { restoreFocus = false } = {}) {
  const trigger = dropdownTriggerFor(menu)

  menu.classList.add("hidden")
  trigger?.setAttribute("aria-expanded", "false")
  if (restoreFocus) trigger?.focus()
}

export function closeOpenDropdowns(root = document) {
  const menus = Array.from(root.querySelectorAll('[data-dropdown-target="menu"]:not(.hidden)'))
  if (menus.length === 0) return false

  menus.forEach((menu, index) => closeDropdownMenu(menu, { restoreFocus: index === 0 }))
  return true
}
